module.exports = __webpack_public_path__ + "img/蒙版组 12.5b52f81e.png";